import LoadingAnimation from "@assets/svg/LoadingAnimation";
import Button from "@components/button/button";
import CustomInput from "@components/CustomInput/CustomInput";
import { login } from "@endpoints/auth.service";
import { linkAccount } from "@endpoints/user.service";
import { loginUser, setUserData } from "@store/actions/auth.action";
import regexList from "@utils/regexList";
import { colors } from "@utils/theme";
import { useSnackbar } from "notistack";
import { Dispatch, SetStateAction, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
} from "@components/ui/dialog";

interface ILoginModal {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
}

const LoginModal = ({ openModal, setOpenModal }: ILoginModal) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const {
    control,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      isLoading: false,
    },
  });
  const fields = watch();

  const handleLogin = async (fields) => {
    try {
      setValue("isLoading", true);
      const { data } = await login(fields);
      const { data: _data } = await linkAccount(data?.token);
      console.log("this is linked account", _data, data);
      dispatch(loginUser(data));
      dispatch(
        setUserData({
          linkedAccount: _data?.linkedAccount,
          user: _data?.user,
        }),
      );
      // if (data?.user?.userType === userTypes.CANDIDATE) {
      //   await fetchCandidateDetails(data);
      // } else if (data?.user?.userType === userTypes.REFERRAL_AMBASSADOR) {
      //
      // }
      window.location.reload();
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      setValue("isLoading", false);
    }
  };

  return (
    <Dialog open={openModal} onOpenChange={setOpenModal}>
      <DialogContent className="bg-white">
        <div className="flex flex-col gap-6 bg-white rounded-lg px-10 min-w-[25%] py-8">
          <label className="font-semibold text-3xl text-center mb-2">
            Login
          </label>
          <label className="text-light-black text-center font-medium">
            Please login to access your account
          </label>
          <form
            className="flex flex-col w-full pt-5"
            onSubmit={handleSubmit(handleLogin)}
          >
            {/* @ts-ignore */}
            <CustomInput
              label={"Email"}
              name="email"
              placeholder={"Enter your Email"}
              rules={{
                required: "This field is required.",
                pattern: {
                  value: regexList.email,
                  message: "Please enter a valid email.",
                },
              }}
              control={control}
              errors={errors}
            />
            <div className="h-6" />
            {/* @ts-ignore */}
            <CustomInput
              label={"Password"}
              placeholder={"Enter your Password"}
              name="password"
              rules={{
                required: "This field is required.",
                pattern: {
                  value: regexList.password,
                  message: "Please enter a valid password.",
                },
              }}
              control={control}
              errors={errors}
            />
            <DialogFooter>
              <Button
                type="submit"
                variant="outline"
                color={colors.TextPrimary}
                onClick={() => setOpenModal(false)}
                className="flex flex-1 items-center justify-center rounded-full mt-10 py-3"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="bg-secondary flex flex-1 items-center justify-center flex-row rounded-full mt-10 py-3"
              >
                <div className="flex">
                  {fields?.isLoading && <LoadingAnimation />}
                  Login
                </div>
              </Button>
            </DialogFooter>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LoginModal;
